export default "__VITE_ASSET__6AXD83fF__"